module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNy40MDgiIGhlaWdodD0iMjEuOTI2IiB2aWV3Qm94PSIwIDAgMjcuNDA4IDIxLjkyNiI+CiAgPHBhdGggaWQ9IlBhdGhfNjQiIGRhdGEtbmFtZT0iUGF0aCA2NCIgZD0iTTI2LjY2Nyw0SDQuNzQxQTIuNzM3LDIuNzM3LDAsMCwwLDIuMDE0LDYuNzQxTDIsMjMuMTg1YTIuNzQ5LDIuNzQ5LDAsMCwwLDIuNzQxLDIuNzQxSDI2LjY2N2EyLjc0OSwyLjc0OSwwLDAsMCwyLjc0MS0yLjc0MVY2Ljc0MUEyLjc0OSwyLjc0OSwwLDAsMCwyNi42NjcsNFptMCw1LjQ4MUwxNS43LDE2LjMzMyw0Ljc0MSw5LjQ4MVY2Ljc0MUwxNS43LDEzLjU5MywyNi42NjcsNi43NDFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMiAtNCkiIGZpbGw9IiM0MGMxYWMiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email.svg
// module id = yko3
// module chunks = 0